<template>
  <nav
    class="bg-surface lg:bg-surface-container-low ease-slow-spatial fixed top-0 left-0 h-screen shrink-0 rounded-r-xl pt-11 transition-all duration-[650ms] lg:relative lg:rounded-none lg:pt-0"
    :class="[!isExpanded && 'w-0 -translate-x-1 lg:w-[96px] lg:translate-x-0']"
    :style="[isExpanded ? { width: navContentWidth ? navContentWidth + 'px' : 'auto' } : {}]"
  >
    <ul
      ref="nav-content"
      class="flex w-full flex-col items-start [&>li]:px-5"
      :class="[isExpanded && 'min-w-[272px]']"
    >
      <li class="hidden w-full items-center pt-4 lg:flex">
        <BaseTextButton @click="backClicked" icon="arrow_back">{{
          $t('common.back')
        }}</BaseTextButton>
      </li>
      <li
        class="relative mt-8 flex max-h-[calc(100vh-12rem)] w-full flex-col overflow-x-hidden overflow-y-auto pb-4 md:mt-14 md:max-h-[calc(100vh-13rem)]"
      >
        <div class="flex flex-col gap-4">
          <CompactRailItem
            :type="itemType"
            icon-name="arrow_back"
            route-name="dashboard"
            :label="$t('common.back')"
            class="text-primary lg:hidden"
            @click="backClicked"
          />
          <RailItemGroup
            v-for="group in navigationItems"
            :id="group.id"
            :key="group.id"
            :item-type="itemType"
            :items="group.items"
            :title="group.title"
            :expandable="false"
            @nav-item-clicked="itemClicked"
          />
        </div>
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
  import { useElementBounding, useWindowSize } from '@vueuse/core'
  import { computed, useTemplateRef } from 'vue'
  import RailItemGroup from './RailItemGroup.vue'
  import { useSettingsNavigation } from '../../composables/use-settings-navigation'
  import BaseTextButton from '../base/button/text-button/BaseTextButton.vue'
  import { useRouter } from 'vue-router'
  import CompactRailItem from './CompactRailItem.vue'

  interface Props {
    isExpanded: boolean
  }

  const props = defineProps<Props>()

  const { width } = useWindowSize()
  const isMobile = computed(() => width.value <= 1024)
  const itemType = computed(() => {
    if (isMobile.value) {
      if (props.isExpanded) {
        return 'expanded'
      } else {
        return 'hidden'
      }
    }
    if (props.isExpanded) {
      return 'expanded'
    }
    return 'collapsed'
  })

  const navContent = useTemplateRef<HTMLAnchorElement>('nav-content')
  const navContentWidth = useElementBounding(navContent).width

  const { navigationItems } = useSettingsNavigation()

  const emits = defineEmits<{
    (e: 'nav-item-clicked'): void
  }>()

  const itemClicked = () => {
    if (isMobile.value) {
      emits('nav-item-clicked')
    }
  }
  const router = useRouter()
  const backClicked = () => {
    if (isMobile.value) {
      emits('nav-item-clicked')
    }
    router.push({ name: 'dashboard' })
  }
</script>
